import SectionHeader from 'components/SectionHeader';
import TooltipIcon from 'components/Tooltip/TooltipIcon';
import {FC} from 'react';
import {t} from 'ttag';

import {PdfFilenameSectionName} from '../../types';

type SectionHeaderProps = {
    sectionName: PdfFilenameSectionName;
};

const PdfFilenameSectionHeader: FC<SectionHeaderProps> = ({sectionName}) => {
    const getString = () => {
        if (sectionName === 'pdfFilenameClient') return t`For Clients`;
        if (sectionName === 'pdfFilenameEmployee') return t`For Users`;
        throw new Error(`Invalid section '${sectionName}'`);
    };
    const getTooltip = () => {
        if (sectionName === 'pdfFilenameClient')
            return t`The filename that your Clients will see when downloading documents`;
        if (sectionName === 'pdfFilenameEmployee')
            return t`The filename that you and other users will see when you download a document`;
        throw new Error(`Invalid section '${sectionName}'`);
    };
    return (
        <SectionHeader
            hideHR={true}
            level={2}
            title={
                <span>
                    {getString()}
                    <TooltipIcon
                        className="ml-2 inline-block h-3.5 text-blue-600"
                        message={getTooltip()}
                        size="base"
                    />
                </span>
            }
        />
    );
};

export default PdfFilenameSectionHeader;
